const moment = require('moment')
//const wangEditor = require('wangEditor')
import config from '../config.js'
/*
 * log
 */
const buildArguments = function(arg) {
	return [].slice.apply(arg).reduce(function(rs, a) {
		if(typeof a === 'object') {
			rs += JSON.stringify(a);
		} else {
			rs += a;
		}
		return rs;
	}, "");
}

const log = function() {
	if(config.debug) console.log(buildArguments(arguments));
}
const debug = function() {
	if(config.debug) console.debug(buildArguments(arguments));
}
const error = function() {
	if(config.debug) console.error(buildArguments(arguments));
}


/* 本地Storage */
const setSessionStorage = function(key, info) {
	return window.sessionStorage.setItem(key, JSON.stringify(info));
}

const getSessionStorage = function(key, _default) {
	_default = typeof _default !== "undefined" ? _default : "{}";
	var obj = window.sessionStorage.getItem(key);
	try {
		obj = JSON.parse(obj);
	} catch(e) {
		obj = null;
	}
	return obj || _default;
}

const setLocalStorage = function(key, info) {
		return window.localStorage.setItem(key, JSON.stringify(info));
	}

const getLocalStorage = function(key, _default) {
		_default = typeof _default !== "undefined" ? _default : "{}";
		return JSON.parse(window.localStorage.getItem(key) || _default);
	}
//返回
const backLink = ()=>{
	window.history.back()
}

/* 正则判断 eg:this.$re_phone(17088338027)*/

/* 手机号码*/
const re_phone = (value) => {
	return /^(13[0-9]|15[0-9]|17[0-9]|18[0-9]|14[57])[0-9]{8}$/.test(value)
}

/*身份证号码*/
const re_identity = (value) => {
	return /^[1-9]{1}[0-9]{14}$|^[1-9]{1}[0-9]{16}([0-9]|[xX])$/.test(value)
}

/*邮政编码*/
const re_postcode = (value) => {
	return /^[1-9]\d{5}(?!\d)$/.test(value)
}
/*URL地址*/
const re_Url = (value) => {
	return /^https?:\/\/(([a-zA-Z0-9_-])+(\.)?)*(:\d+)?(\/((\.)?(\?)?=?&?[a-zA-Z0-9_-](\?)?)*)*$/i.test(value)
}
/*Email地址*/
const re_Email = (value) => {
	return /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/.test(value)
}

/*只能是中文*/
const re_Chinese = (value) => {
	return /[\u4e00-\u9fa5]/gm.test(value)
}
/*只能是数字*/
const re_Number = (value) => {
	return /^\d+$/.test(value)
}

/*只能是英文*/
const re_English = (value) => {
	return /^[a-z]+$/i.test(value)
}

/*去掉空格*/
const re_deleteSpace = (value) => {
	return value.replace(/\s+/g, "")
	//	alert(value.replace(/\s+/g,""))
}

/*只能输入数字和小数点(二位小数点)*/
const re_twoPoint = (value) => {
	return /^\d+(?:\.\d{1,2})?$/.test(value)
}
/*经度正则*/
const re_longitude = (value)=>{
	return  /^[\-\+]?(0?\d{1,2}\.\d{1,12}|1[0-7]?\d{1}\.\d{1,12}|180\.0{1,12})$/.test(value)
}
/*纬度正则*/
const re_latitude = (value)=>{
	return  /^[\-\+]?([0-8]?\d{1}\.\d{1,12}|90\.0{1,12})$/.test(value)
}
/*是否为合法的url*/
const re_Isurl = (value) => {
	var RegUrl = new RegExp(); 
	RegUrl.compile("^[A-Za-z]+://[A-Za-z0-9-_]+\\.[A-Za-z0-9-_%&\?\/.=]+$");//jihua.cnblogs.com 
	if (!RegUrl.test(value)) {
		return false; 
	} 
	return true;
}


//获取几天前的日期
const getDateBySubtract = (num) => {
	return moment().subtract(num, 'days').format("YYYY-MM-DD");
}

//获取几天后的日期
const getDateByAdd = (num) => {
	return moment().add(num, 'days').format("YYYY-MM-DD");
}
//获取当前时间
const getCurrentDate = () => {
	return moment().format("YYYY-MM-DD");
}

//获取unix时间戳（秒）
const getUnixTime = (value) => {
	return moment(value).unix();
}

//将unix时间戳转化
const parseUnixTime = (value) => {
	return moment(value * 1000).toArray();
}

//获取完整年月日时分秒
const getCurrentDateTime = (value) => {
	return moment(value).format("YYYY-MM-DD HH:mm:ss");
}

//获取标准时间ISO 8601 字符串
const getISOStringTime = (value) => {
	return moment(value).toISOString();
}

//将标准时间转化为数组形式
const parseTimeToArray = (value) => {
	return moment(value).toArray();
}

//判断是否为正整数
const re_trueNumber = (value) => {
	let re = /^[1-9]+[0-9]*]*$/;
	if (!re.test(value)) {
		return false;
	} else {
		return true;
	}
}

const filterMoney = (money = 0) => {
	if(typeof money === 'string') {
		money = parseInt(money);
	}
	return(money / 100).toFixed(2);
}
//初始化图表
const echartsInit =(id,options)=>{
	return echarts.init(document.getElementById(id),'wonderland',options)
}

//实例化编辑器
const editorInit = (id)=>{
        let editor = new wangEditor(id)
//		editor.customConfig.menus = config;
//		editor.customConfig.menuFixed = false;
   		editor.customConfig.uploadImgServer = '/api/editUploads';
   		editor.customConfig.uploadFileName = 'file';
   		editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024; //将图片大小限制为 3M
		editor.customConfig.uploadImgMaxLength = 1; //// 限制一次最多上传 5 张图片
   		 editor.customConfig.zIndex = 1;
   		if(typeof(editor.customConfig)!="undefined") editor.customConfig.debug = 0;
		editor.create();
	return editor
}

//二维码生成
const qrcodeInit = (options ={})=>{
	if(typeof(options)=="undefined" || !options.id || !options.text) return console.error('参数有误!')
	
	let id = options.id,
		text =  options.text,
		width = options.width || 100,
		height = options.height || 100,
		colorDark = options.colorDark || "#000000",
		colorLight = options.colorLight || "#ffffff"

	return new QRCode(document.getElementById(id), {
		text: text,
		width: width ,
		height: height,
		colorDark : colorDark,
		colorLight : colorLight 
//		correctLevel : QRCode.CorrectLevel.H
	})
	
}

export default {
	install(Vue) {
		Vue.prototype.$log = log
		Vue.prototype.$debug = debug
		Vue.prototype.$error = error
		Vue.prototype.$back = backLink
		Vue.prototype.$setSessionStorage = setSessionStorage
		Vue.prototype.$getSessionStorage = getSessionStorage
		Vue.prototype.$setLocalStorage = setLocalStorage
		Vue.prototype.$getLocalStorage = getLocalStorage
		Vue.prototype.$re_phone = re_phone
		Vue.prototype.$re_identity = re_identity
		Vue.prototype.$re_postcode = re_postcode
		Vue.prototype.$re_Email = re_Email
		Vue.prototype.$re_Url = re_Url
		Vue.prototype.$getUnixTime = getUnixTime
		Vue.prototype.$re_Number = re_Number
		Vue.prototype.$re_Chinese = re_Chinese
		Vue.prototype.$re_identity = re_identity
		Vue.prototype.$re_English = re_English
		Vue.prototype.$re_deleteSpace = re_deleteSpace
		Vue.prototype.$re_twoPoint = re_twoPoint,
		Vue.prototype.$re_longitude = re_longitude,
		Vue.prototype.$re_latitude = re_latitude,
		Vue.prototype.$re_Isurl = re_Isurl,
		Vue.prototype.$getDateBySubtract = getDateBySubtract
		Vue.prototype.$getDateByAdd = getDateByAdd
		Vue.prototype.$getCurrentDate = getCurrentDate
		Vue.prototype.$parseUnixTime = parseUnixTime
		Vue.prototype.$getCurrentDateTime = getCurrentDateTime
		Vue.prototype.$re_trueNumber = re_trueNumber
		Vue.prototype.$getISOStringTime = getISOStringTime
		Vue.prototype.$parseTimeToArray = parseTimeToArray
		Vue.prototype.$filterMoney = filterMoney
		Vue.prototype.$echartsInit = echartsInit
		Vue.prototype.$editorInit = editorInit
		Vue.prototype.$qrcodeInit = qrcodeInit
		
	},
	setSessionStorage,
	getSessionStorage,
	setLocalStorage,
	getLocalStorage,
	log,
	debug,
	error
}


// WEBPACK FOOTER //
// ./src/extend/index.js